import { Box, Button, Typography } from "@mui/material";
import React from "react";
import "./CountDown.css";
import Countdown from "react-countdown";
import Count from "../../../molecules/Count/Count";
import { Images } from "../../../../helpers/Images";
import { useNavigate } from "react-router-dom";

const CountDown = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        padding: {
          xs: "50px 20px",
          sm: "50px 60px",
          lg: "50px 120px",
          xl: "150px 120px",
        },
        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${Images.gold})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "500px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography
        variant={"h1"}
        sx={{
          textAlign: "center",
          fontSize: { xs: "50px", sm: "55px" },
          fontWeight: "500",
          color: "secondary.main",
        }}
      >
        Welcome to International Robot Challenge 2025
      </Typography>
      <Typography
        variant={"h2"}
        sx={{
          textAlign: "center",
          fontSize: { xs: "20px", sm: "30px" },
          fontWeight: "500",
          marginTop: "5px",
          color: "secondary.main",
        }}
      >
        ~ 04 - 10 - 2025 ~
      </Typography>
      <Countdown
        date={"2025-10-04T24:00:00"}
        intervalDelay={0}
        precision={3}
        renderer={(props) => (
          <Count
            days={props.days}
            hours={props.hours}
            minutes={props.minutes}
            seconds={props.seconds}
          />
        )}
      />

      {/* <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          marginTop: "20px",
        }}
      >
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1BoovUk_TMGUZAttJUgNj3yAATC_3MkKt"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            IRC agenda
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1HBGRGhJZzunnbvs_wmMujlpV0VNw9bZG"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            sumo lego schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1_Bf-5rfAm4jVC0AE7fQEflkyIZIg17_T"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            sumo mega schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1qwTJICU0DrdDVPHZpo1mO7mXjGcLl4u7"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            sumo mini schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=17cmwlFknJq9Z99tFHJZGt977DMzJdsWA"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            follow line lego schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1n2fsA1JIMdFOBNU9YHW9WfxM5YeAJmLa"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            follow line open schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1KG6UuOPsIWPuw5-1tFvEuFeAYiCwKAd_"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            follow line enhanced schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1v4V7Y17AaRYA7sYPjUCvS2RcSx1u-ZP4"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            bowling schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1mQAKPVIu1hE2ZJCWKZB82X_tYm_kgH0z"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            puck collect schedule
          </Button>
        </a>
        <a
          download
          href={
            "https://drive.google.com/uc?export=download&id=1NsaSBuoMBOR0nVcvZUhYkkMI8Eor94jS"
          }
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              margin: "25px 10px 0",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            free style schedule
          </Button>
        </a>
      </Box> */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
          marginTop: "20px",
        }}
      >
        {/* <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          color="secondary"
          sx={{
            fontSize: "17px",
            marginTop: "25px",
            fontWeight: "600",
            backgroundColor: "secondary.main",
            color: "primary.main",
          }}
          onClick={() => navigate("/firststage")}
        >
          Register Now
        </Button>
      </Box> */}
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              marginTop: "25px",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
              mx: 1,
            }}
            onClick={() => navigate("/files")}
          >
            Download 2025 Schedules
          </Button>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              fontSize: "17px",
              marginTop: "25px",
              fontWeight: "600",
              backgroundColor: "secondary.main",
              color: "primary.main",
              mx: 1,
            }}
            onClick={() => navigate("/scores")}
          >
            Live Scores
          </Button>
        </Box>
        {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
          <a
            download
            href={
              "https://drive.google.com/uc?export=download&id=1_DXgoDNJx6axef2J-hWuHMuaigODEKk-"
            }
          >
            <Button
              variant="contained"
              color="secondary"
              sx={{
                fontSize: "17px",
                marginTop: "25px",
                fontWeight: "600",
                backgroundColor: "secondary.main",
                color: "primary.main",
                width: { xs: "300px", sm: "300px" },
              }}
            >
              International Robot Challenge Schedule
            </Button>
          </a>
        </Box> */}
      </Box>
    </Box>
  );
};

export default CountDown;

// RobotChallenge is one of the biggest competitions for self-made, autonomous and mobile robots worldw
